import { formatNumber } from "helpers/system";
import React from "react";

export default function Indicators(props) {
    const { overallMileage, overallBidsPrice, output, outputPerHour, currency } = props;

    return (
        <>
            <div className="d-flex justify-content-between">
                <div data-test-id="trip-planning-overall-mileage">
                    {formatNumber(overallMileage)} <span className="text-muted">км</span>
                </div>
                <div data-test-id="trip-planning-output-per-kilometer">
                    {formatNumber(output)} <span className="text-muted">{currency}/км</span>
                </div>
            </div>
            <div className="d-flex justify-content-between">
                <div data-test-id="trip-planning-output-per-hour">
                    {formatNumber(outputPerHour)} <span className="text-muted">{currency}/час</span>
                </div>
                <div data-test-id="trip-planning-overall-bids-price">
                    {formatNumber(overallBidsPrice)} <span className="text-muted">{currency}</span>
                </div>
            </div>
        </>
    );
}
